const mutations = {
    setMyCompanyMocker(state,payload){
        state.me.company = payload
    },
    setMe(state,payload){
        let user =  checkUserRole(payload)
        state.me =user
    },
    setUsers(state,payload) {
        state.users = payload
    }
}

export default mutations



function checkUserRole(user) {

    if(user.type === "user"){
        user.user = true
    }
    if(user.type === "admin"){
        user.user = true, user.admin = true
    }
    if(user.type === "root"){
        user.user = true, user.admin = true, user.root = true
    }

    return user
}